import { useQuery } from "@tanstack/react-query";
import {
	dashboardService,
	DashboardKPISummaryFilters,
} from "../../services/dashboard.service";

const canonicalize = (ids: string[] | undefined): string =>
	[...(ids ?? [])].sort().join(",");

const useDashboardKPISummary = (filters: DashboardKPISummaryFilters) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery({
		queryKey: [
			"dashboard-kpi-summary",
			filters.accountId,
			filters.programId,
			canonicalize(filters.orgUnitIds),
			filters.providerId ?? "",
			filters.dateRange,
		],
		queryFn: () => dashboardService.getKPISummary(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useDashboardKPISummary;
